import { render, staticRenderFns } from "./wedding.vue?vue&type=template&id=9f13ebda&scoped=true&"
import script from "./wedding.vue?vue&type=script&lang=js&"
export * from "./wedding.vue?vue&type=script&lang=js&"
import style0 from "./wedding.vue?vue&type=style&index=0&id=9f13ebda&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f13ebda",
  null
  
)

export default component.exports